import Swiper from 'swiper';
import gsap from 'gsap';
import {BREAKPOINTS} from '../constants';

new Swiper('.js-team-slider', {
  slidesPerView: 'auto',
  centeredSlides: false,
  // spaceBetween: 134,
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
    draggable: true,
  },
  breakpoints: {
    [BREAKPOINTS.sm]: {
      centeredSlides: false,
      // spaceBetween: 20,
    },
    [BREAKPOINTS.md]: {
      centeredSlides: true,
    },
  },
});

const gallerySlider = new Swiper('.js-gallery', {
  slidesPerView: 1,
  centeredSlides: false,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});

const galleryCaptionSlider = new Swiper('.js-gallery-caption', {
  slidesPerView: 1,
  centeredSlides: false
});

const $contactsGallery = $('.js-contacts-gallery');
const delay = $contactsGallery.data('autoplay');
const speed = $contactsGallery.data('speed');
new Swiper('.js-contacts-gallery', {
  slidesPerView: 1,
  effect: 'fade',
  fadeEffect: { crossFade: true },
  loop: true,
  allowTouchMove: false,
  speed,
  spaceBetween: 1,
  autoplay: {delay},
});

const heroImageSlider = new Swiper('.js-hero-image-slider', {
  slidesPerView: 1,
  centeredSlides: false,
  speed: 500,
  loop: true,
  spaceBetween: 1,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});

const heroContentSlider = new Swiper('.js-hero-content-slider', {
  slidesPerView: 1,
  centeredSlides: false,
  effect: 'fade',
  fadeEffect: { crossFade: true },
  loop: true,
  allowTouchMove: false,
  on: {
    init: function() {
      const $content = $(this.slides[this.activeIndex]).find('.js-hero-item');
      gsap.timeline().fromTo($content, {opacity: 0}, {opacity: 1});
    },
    transitionStart: function() {
      const $content = $(this.slides[this.activeIndex]).find('.js-hero-item');
      gsap.timeline().fromTo($content, {opacity: 1}, {opacity: 0});
    },
    transitionEnd: function() {
      const $content = $(this.slides[this.activeIndex]).find('.js-hero-item');
      gsap.timeline().fromTo($content, {opacity: 0}, {opacity: 1});
    }
  }
});

heroImageSlider.controller && (heroImageSlider.controller.control = heroContentSlider);
heroContentSlider.controller && (heroContentSlider.controller.control = heroImageSlider);

galleryCaptionSlider.controller && (galleryCaptionSlider.controller.control = gallerySlider);
gallerySlider.controller && (gallerySlider.controller.control = galleryCaptionSlider);

// heroContentSlider.on('slideChangeTransitionStart', function() {
//   const $content = $(this.slides[this.activeIndex]).find('.js-hero-item');
//   gsap.timeline().fromTo($content, {opacity: 1}, {opacity: 0});
// });
//
// heroContentSlider.on('slideChangeTransitionEnd', function() {
//   const $content = $(this.slides[this.activeIndex]).find('.js-hero-item');
//   gsap.timeline().fromTo($content, {opacity: 0}, {opacity: 1});
// });
